import PhoneInputNumber from "react-phone-number-input";

import "react-phone-number-input/style.css";
import "./style.css";

const PhoneInput = ({ placeholder, value, onChange }) => {
  return (
    <PhoneInputNumber
      style={styles.phone}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
  );
};

const styles = {
  phone: {},
};

export default PhoneInput;
